import type { ExpandedListItem } from './type';

export const doAnyItemList =
  <T extends Dictionary>(itemByUuid: { [uuid: string]: ExpandedListItem<T> }) =>
  (
    itemList: (ExpandedListItem<T> | string)[],
    callback: (itemList: ExpandedListItem<T>[]) => any,
  ) => {
    const list = itemList.map(i => (typeof i === 'string' ? itemByUuid[i] : i));

    callback(list);
  };
export const getExt = (value: string) => value.match(/\.((\w|\d)+)$/gi)?.[0];
export const genIsExt = (ext: RegExp) => (value: string) => ext.test(value);
export const isImage = genIsExt(/png|jp(e?)g|webp|svg|gif/);
export const isPcd = genIsExt(/pcd/);
